module.exports = __webpack_public_path__ + "img/cl-install-C50-connection_12200.495ea9c0.png";